/* =============================================================================
   TUCHMASKENDEAL – Gruppen-Pruefung (A & B)
   JET CEUTICALS – Theme "Kopie von jcs-shop/main Trade Angebot"
   -----------------------------------------------------------------------------
   KEINE Sperre, KEINE Meldung, KEIN Button-Deaktivieren.
   Diese Datei liefert nur die Pruefung, ob der Warenkorb den Deal erfuellt:
     - GRUPPE A: BEIDE Produkte muessen drin sein (Waschgel UND Aloe Mist)
     - GRUPPE B: EIN Produkt reicht (Exosome Luxus ODER Pure)
   Der Loader in der theme.liquid nutzt das Ergebnis, um zu entscheiden:
     erfuellt  -> weiter zum Checkout + Code anwenden
     nicht     -> zurueck zum Warenkorb, Code NICHT anwenden
   ============================================================================= */
(function () {
  'use strict';

  /* ============================ KONFIGURATION ============================== */
  var CONFIG = {
    // GRUPPE A – ALLE diese Produkte muessen im Warenkorb liegen
    gruppeA: [10527545524517, 10527537201445], // WASCHGEL DRY SKIN, ALOE CALMING MIST
    // GRUPPE B – EINES dieser Produkte reicht
    gruppeB: [10504793424165, 10504230076709]  // EXOSOME CELL LUXURY CREAM (Luxus / Pure)
  };
  /* ======================================================================== */

  var lastValid = false;

  function toId(x) { return parseInt(x, 10); }

  // Prueft einen Warenkorb (aus /cart.js) gegen die Gruppen-Regeln
  function checkCart(cart) {
    var items = (cart && cart.items) || [];
    var da = {};
    items.forEach(function (it) { da[toId(it.product_id)] = true; });
    var hasA = CONFIG.gruppeA.every(function (id) { return da[id]; }); // beide
    var hasB = CONFIG.gruppeB.some(function (id) { return da[id]; });  // eines
    return hasA && hasB;
  }

  // Warenkorb frisch laden und Zustand aktualisieren; optional Callback(valid, cart)
  function refresh(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastValid = checkCart(cart);
        if (typeof cb === 'function') cb(lastValid, cart);
      })
      .catch(function () { if (typeof cb === 'function') cb(lastValid, null); });
  }

  // Nach jeder Cart-Mutation neu pruefen
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      }
      return p;
    };
  }

  ['cart:refresh', 'cart:updated', 'cart:build', 'cart-drawer:open']
    .forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 60); }); });

  document.addEventListener('DOMContentLoaded', function () { refresh(); });
  if (document.readyState !== 'loading') refresh();
  setInterval(refresh, 4000);

  /* ---- Oeffentliche API fuer den Loader --------------------------------- */
  window.TuchmaskenLock = {
    isValid: function () { return lastValid; },   // letzter bekannter Zustand
    isValidCart: function (cart) { return checkCart(cart); }, // Ad-hoc-Pruefung
    refresh: refresh
  };
})();
